/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/6
 */
import React, {Component} from 'react';
import Step from '../step';
import scrollToTop from '../../utils/scrollToTop';
import setTitle from '../../utils/setTitle';
import {connect} from 'react-redux';
import {getProductOptions, toEvaluate} from '../../actions/step';
import Info from '../step/info';
import Select from "./select/index";

class Step1 extends Component {
  constructor (props) {
    super(props);
    const { options, getProductOptions, match } = this.props;
    let loading = false;
    scrollToTop();
    setTitle('在线估值');

    if (!options.id || match.params.pid !== options.id) {
      loading = true;
      getProductOptions(match.params.pid);
    }
    this.state = {
      loading
    };
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.options.id) {
      this.setState({
        loading: false
      });
    }
  }
  render (){
    const { options, unLock, toEvaluate, match } = this.props;
    const opts = options.id && options.id === match.params.pid ? options : {};
    return <Step step={1} loading={this.state.loading}>
      <Info {...opts} />
      <Select {...opts} unLock={unLock} toEvaluate={toEvaluate} />
    </Step>
  }
}

export default connect(
  (state) => ({
    unLock: state.step.selected.unLock,
    options: state.step.options
  }),
  {getProductOptions, toEvaluate}
)(Step1);



// WEBPACK FOOTER //
// ./src/components/step1/index.js